export const MercadoPagoIcon = () => <img src={'/mercadoPago.svg'} alt="Mercado Pago" />;
